import { breakpoints } from '@verbit-ai/verbit-ui-library'

import { paletteChromakey } from './palette.chromakey'
import { paletteDark } from './palette.dark'
import { paletteDefault } from './palette.default'
import { paletteHighContrast } from './palette.high-contrast'
import { Palette, ThemeCore, ThemeType } from './types'

export const themeCore: ThemeCore = {
    breakPoints: {
        mobilePhoneMaxWidth: breakpoints.mobilePhoneMaxWidth,
        tabletMaxWidth: breakpoints.tabletMaxWidth,
        laptopMaxWidth: breakpoints.laptopMaxWidth,
    },

    zIndexes: {
        appHeader: 2,
        trancriptToolbar: 1,
    },

    dimensions: {
        trancriptToolbarHeight: 78,
        trancriptToolbarHeightMobile: 80,
    },
}

export const themePalettes: Record<ThemeType, Palette> = {
    default: paletteDefault,
    dark: paletteDark,
    highContrast: paletteHighContrast,
    chromakey: paletteChromakey,
}
